export default {

    SET_ERROR: "SET_ERROR",

    CLEAR_ERROR: "CLEAR_ERROR",

};